import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {AnalyticsVisualizationAggregationType as AggregationType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {AGGREGATION_TYPE_TO_READABLE} from 'insights/analytics-visualizations/AnalyticsVisualizationConstants';
import {StringValueDropdownSelector} from 'insights/analytics-visualizations/configs/form-components/DropdownSelector';
import {AggregationAndErrorBarParameters} from 'insights/analytics-visualizations/configs/VisualizationConfigEditorTypes';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface AggregationConfigEditorProps<ChartParameters extends AggregationAndErrorBarParameters> {
  parameters: ChartParameters;
  onUpdateParameters: (update: Partial<ChartParameters>) => void;
}

export const ORDERED_AGGREGATION_TYPES = [AggregationType.COUNT, AggregationType.MEAN, AggregationType.SUM];

/**
 * Settings to configure point aggregation. To prevent invalid combinations of error bar and point aggregation
 * settings, this component also updates errorBarType.
 */
export default function AggregationConfigEditor<ChartParameters extends AggregationAndErrorBarParameters>({
  parameters,
  onUpdateParameters,
}: AggregationConfigEditorProps<ChartParameters>): JSX.Element {
  return (
    <div
      className="u-input-spacing-top"
      {...getTestProps({component: 'AggregationConfigEditor', element: 'root'})}
    >
      <FieldLabel label="Aggregation" />
      <StringValueDropdownSelector
        allowNull={true}
        onChange={(newAggregationType) => {
          onUpdateParameters({
            ...parameters,
            aggregationType: newAggregationType,
            // Error bars require aggregating points, so turn error bars off when turning aggregation off
            errorBarType: newAggregationType == null ? null : parameters.errorBarType,
          });
        }}
        searchable={false}
        selectedValue={parameters.aggregationType}
        values={ORDERED_AGGREGATION_TYPES}
        valueToReadable={(aggregationType) => AGGREGATION_TYPE_TO_READABLE[aggregationType]}
      />
    </div>
  );
}
